import React from "react";

export type ProgressStep = {
  label: string;
  completed: number;
  total: number;
} & { readonly __brand: unique symbol };

export const createProgressStep = (
  label: string,
  completed: number,
  total: number
): ProgressStep => ({ label, completed, total } as ProgressStep);

export type StepStatus = "not-started" | "in-progress" | "completed";

export function getStepStatus(step: ProgressStep): StepStatus {
  if (step.completed === 0) {
    return "not-started";
  }
  if (step.completed < step.total) {
    return "in-progress";
  }
  return "completed";
}

export interface CompanyInfo {
  teamName: string;
  advisorName: string;
}

export interface TransitionProgressIndicatorProps {
  steps: ProgressStep[];
  className?: string;
  progressInfo?: React.ReactNode;
  companyInfo?: CompanyInfo;
}
